module.exports = __webpack_public_path__ + "img/load-5-1.0bdece5a.png";